import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Image,
  Header,
  Divider,
  Icon,
  Grid,
  Button,
  Confirm,
  Modal,
  Form,
  Dropdown,
  TextArea,
  Container,
  Label
} from "semantic-ui-react";
import _ from "lodash";

import ClubMap from "../Maps/ClubMap";
import ClubTeams from "./ClubTeams";
import SocialLinks from "./SocialLinks";
import { LOGIN_ROUTE } from "../../constants/route.constants";
import { APP_NAME } from "../../constants/resource.constants";
import { updateClub, contactClub } from "../../modules/club/api";
import { subjects } from "../../data/getintouch.subjects.data";
import { GetInTouchClubModel } from "../../models";
import FixturesList from "../Fixtures/FixturesList";

class Club extends Component {
  constructor(props) {
    super(props);
    this.state = {
      markers: [],
      followers: [],
      notAuthModalOpen: false,
      isContactModalOpen: false,
      showContactErrorMsg: false,
      contact: {
        subject: "",
        message: ""
      },
      contactErrors: {}
    };
  }

  componentDidMount() {
    this.setState({
      markers: [
        {
          position: {
            lat: this.props.club.latitude,
            lng: this.props.club.longitude
          },
          key: this.props.club.city,
          defaultAnimation: 2,
          showInfo: false,
          club: this.props.club
        }
      ],
      followers: this.props.club.followers || []
    });

    this.handleMarkerClick = this.handleMarkerClick.bind(this);
    this.handleMarkerClose = this.handleMarkerClose.bind(this);
    this.handleFollowClick = this.handleFollowClick.bind(this);
    this.handleGetInTouchClick = this.handleGetInTouchClick.bind(this);
    this.isUserFollowingClub = this.isUserFollowingClub.bind(this);
    this.isUserUnauthenticated = this.isUserUnauthenticated.bind(this);
    this.handleAuthModalCancel = this.handleAuthModalCancel.bind(this);
    this.handleAuthModalConfirm = this.handleAuthModalConfirm.bind(this);
    this.handleCloseContactModal = this.handleCloseContactModal.bind(this);
    this.handleSubmitContactModal = this.handleSubmitContactModal.bind(this);
    this.handleContactFormChange = this.handleContactFormChange.bind(this);
  }

  // Toggle to 'true' to show InfoWindow and re-renders component
  handleMarkerClick(targetMarker) {
    this.setState({
      markers: this.state.markers.map(marker => {
        if (marker === targetMarker) {
          return {
            ...marker,
            showInfo: true
          };
        }
        return marker;
      })
    });
  }

  handleMarkerClose(targetMarker) {
    this.setState({
      markers: this.state.markers.map(marker => {
        if (marker === targetMarker) {
          return {
            ...marker,
            showInfo: false
          };
        }
        return marker;
      })
    });
  }

  isUserUnauthenticated() {
    return !this.props.user || !this.props.user.email;
  }

  handleGetInTouchClick() {
    if (this.isUserUnauthenticated()) {
      this.setState({ notAuthModalOpen: true });
      return;
    }

    this.setState({ isContactModalOpen: true, showContactErrorMsg: false });
  }

  handleCloseContactModal() {
    this.setState({ isContactModalOpen: false, showContactErrorMsg: false });
  }

  handleSubmitContactModal() {
    const model = new GetInTouchClubModel(
      this.props.user,
      this.props.club,
      this.state.contact
    );

    const contactErrors = model.validate();
    this.setState({ contactErrors });
    if (!_.isEmpty(contactErrors)) {
      return;
    }

    contactClub(model).then(response => {
      console.log("response", response);

      if (
        (response && response.code) ||
        (response && response.emailSent === false)
      ) {
        // TODO: Show unsuccessful message to user
        this.setState({ showContactErrorMsg: true });
      } else {
        this.setState({ isContactModalOpen: false });
      }
    });
  }

  handleAuthModalCancel() {
    this.setState({ notAuthModalOpen: false });
  }

  handleAuthModalConfirm() {
    this.setState({ notAuthModalOpen: false });
    this.props.history.push(`${LOGIN_ROUTE}?next=${window.location.pathname}`);
  }

  isUserFollowingClub() {
    const userId =
      this.props.user && this.props.user._id ? this.props.user._id : 0;
    return _.indexOf(this.state.followers, userId) >= 0;
  }

  handleFollowClick() {
    if (this.isUserUnauthenticated()) {
      this.setState({ notAuthModalOpen: true });
      return;
    }

    if (this.isUserFollowingClub()) {
      return;
    }
    console.log("state", this.props.club);

    const followers = this.state.followers;
    followers.push(this.props.user._id);

    updateClub(this.props.club._id, {
      followers: followers,
      numOfFollowers: followers.length
    }).then(response => {
      this.setState(response.followers);
    });
  }

  handleContactFormChange(e, { name, value }) {
    const contact = this.state.contact;
    contact[name] = value;
    this.setState({ contact });
  }

  render() {
    const club = this.props.club;
    club.latitude = parseFloat(club.latitude);
    club.longitude = parseFloat(club.longitude);

    const imgPath = () => {
      return club.img || "/img/crest.svg";
    };

    const createDescriptionMarkup = () => {
      return { __html: club.about ? club.about : "" };
    };

    return (
      <div>
        <Grid>
          <Grid.Column width={11}>
            <Header as="div" className="club-page__header">
              <Image src={imgPath()} size="big" />
              <Header.Content>
                <h1>{club.name}</h1>
                <Header.Subheader>
                  <Icon name="marker" />
                  {club.city}, {club.state}, {club.country}
                  <ClubTeams teams={club.teams} />
                </Header.Subheader>
              </Header.Content>
            </Header>
          </Grid.Column>
          <Grid.Column width={5} textAlign="right">
            <SocialLinks club={club} />
            <div className="clear" />
            {club.isEmailVerified ? (
              <Button
                as="a"
                negative
                onClick={this.handleGetInTouchClick}
                className="club-request-btn"
              >
                Get in touch
              </Button>
            ) : (
              " "
            )}
            <div className="club-page__header-follow-btn">
              <Button
                content={this.isUserFollowingClub() ? "Following" : "Follow"}
                icon="feed"
                label={{
                  as: "a",
                  basic: true,
                  content:
                    this.state.followers && this.state.followers.length
                      ? this.state.followers.length
                      : 0
                }}
                labelPosition="right"
                floated="right"
                onClick={this.handleFollowClick}
              />
            </div>
            <div className="club-page__header-follow-btn">
              {club.isActive ? (
                ""
              ) : (
                <Label as="a" color="red" basic size="large">
                  Defunct
                </Label>
              )}
            </div>
            <div className="addthis_inline_share_toolbox" />
            <Confirm
              open={this.state.notAuthModalOpen}
              onCancel={this.handleAuthModalCancel}
              onConfirm={this.handleAuthModalConfirm}
              header={`Login to ${APP_NAME}`}
              confirmButton="Login now"
              content="You must log in to continue."
            />
            <Modal
              open={this.state.isContactModalOpen}
              onClose={this.handleCloseContactModal}
              size="small"
            >
              <Modal.Header>
                <Image src={imgPath()} size="mini" floated="left" />
                Get in touch with {club.name}
              </Modal.Header>
              <Modal.Content image>
                <Modal.Description>
                  <Form>
                    <Form.Field>
                      <label>Subject</label>
                      {this.state.contactErrors.subject &&
                      this.state.contactErrors.subject.hasError ? (
                        <span className="error">
                          {this.state.contactErrors.subject.message}
                        </span>
                      ) : (
                        " "
                      )}
                      <Dropdown
                        className="inline-form-editing"
                        placeholder="Select a subject"
                        selection
                        options={subjects}
                        onChange={this.handleContactFormChange}
                        name="subject"
                        value={this.state.contact.subject}
                        fluid
                        error={
                          this.state.contactErrors.subject &&
                          this.state.contactErrors.subject.hasError
                        }
                      />
                    </Form.Field>
                    <Form.Field>
                      <label>Message</label>
                      {this.state.contactErrors.message &&
                      this.state.contactErrors.message.hasError ? (
                        <span className="error">
                          {this.state.contactErrors.message.message}
                        </span>
                      ) : (
                        " "
                      )}
                      <TextArea
                        placeholder="Write your message..."
                        onChange={this.handleContactFormChange}
                        name="message"
                        value={this.state.contact.message}
                        className={
                          this.state.contactErrors.message &&
                          this.state.contactErrors.message.hasError
                            ? "error inline-form-editing"
                            : "inline-form-editing"
                        }
                      />
                    </Form.Field>
                  </Form>
                  {this.state.showContactErrorMsg ? (
                    <div>
                      <br />
                      <Label as="a" basic color="red">
                        <Icon color="red" name="warning circle" /> Message could
                        not be sent. Please try again later.
                      </Label>
                    </div>
                  ) : (
                    ""
                  )}
                </Modal.Description>
              </Modal.Content>
              <Modal.Actions>
                <Button color="grey" onClick={this.handleCloseContactModal}>
                  Close
                </Button>
                <Button
                  positive
                  icon="checkmark"
                  labelPosition="right"
                  content="Send"
                  onClick={this.handleSubmitContactModal}
                />
              </Modal.Actions>
            </Modal>
          </Grid.Column>
        </Grid>
        <Divider />
        <Container fluid text>
          <Header as="h2">About</Header>
          <article dangerouslySetInnerHTML={createDescriptionMarkup()} />
        </Container>
        <br />
        <Grid divided="vertically" stackable={true}>
          <Grid.Row columns={2}>
            <Grid.Column>
              <h3>Location</h3>
              {this.state.markers.length > 0 && this.props.club.latitude ? (
                <ClubMap
                  markers={this.state.markers}
                  zoom={"13"}
                  onMarkerClick={this.handleMarkerClick}
                  onMarkerClose={this.handleMarkerClose}
                />
              ) : (
                "No location available."
              )}
            </Grid.Column>
            <Grid.Column>
              <h3>Fixtures</h3>
              {this.props.fixtures && this.props.fixtures.length > 0 ? (
                <FixturesList
                  fixtures={this.props.fixtures}
                  history={this.props.history}
                  clubId={this.props.club._id}
                />
              ) : (
                "No fixtures."
              )}
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
    );
  }
}

Club.propTypes = {
  club: PropTypes.shape({
    _id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    state: PropTypes.string.isRequired,
    country: PropTypes.string.isRequired,
    followers: PropTypes.array
  }).isRequired
};

export default Club;



// WEBPACK FOOTER //
// ./src/components/Club/Club.js